// extracted by mini-css-extract-plugin
export default {"item":"item_item__6a2dp","icon":"item_icon__Ng7vy","title":"item_title__rGukU"};